<template>
  <Button
    label="Sign Out"
    icon="pi pi-sign-out"
    severity="secondary"
    :loading="isLoading"
    :disabled="isLoading"
    @click="handleSignOut"
    class="logout-button"
  />
</template>

<script setup lang="ts">
import Button from 'primevue/button';
import { useAuth } from '../../composables/useAuth.js';

const { signOut, isLoading } = useAuth();

const handleSignOut = async () => {
  await signOut();
};
</script>

<style scoped>
.logout-button {
  width: 100%;
}
</style>
